export enum FormOfAddress {
    Mr = 0,
    Mrs = 1,
    Neutral = 2,
}
